import React from 'react'
import {Link} from 'react-router-dom'
import Events from '../../api/blogs'

const EventSection4 = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(
        <div className="wpo-event-area-s2 bg-green section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="wpo-section-title">
                            <span>Radionice</span>
                            <h2>Održane radionice i najave događaja </h2>
                            <p>Mnogi ljudi kako prije, tako i sada promatraju šumu kao personifikaciju prirode. Zapravo ni jedna druga životna zajednica nije toliko podesna za neposredni doživljaj prirode, neograničeno pristupačna, a ljudima uz čisto prirodno-znanstvenu omogućuje i estetsku te emocionalnu spoznaju.</p>
                        </div>
                    </div>
                </div>
                <div className="wpo-event-wrap">
                    <div className="row justify-content-center">
                        <div className="col col-lg-10">
                            {Events.slice(6,8).map((event, eitem)=>(
                                <div className="wpo-event-single" key={eitem}>
                                    <div className="wpo-event-item">
                                        <div className="wpo-event-img">
                                            <img src={event.eImg} alt=""/>
                                        </div>
                                        <div className="wpo-event-content">
                                            <div className="wpo-event-text-top">
                                                <span>{event.date}</span>
                                                <h2><Link onClick={ClickHandler} to={`/event-single/${event.id}`}>{event.eTitle}</Link></h2>
                                                <p>{event.dec}</p>
                                                <Link onClick={ClickHandler} className="read-more" to={`/event-single/${event.id}`}>Saznaj više...</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventSection4;